import { Button, CheckRow, SelectField, cx } from '../ui';
import { Swatch } from '../../charts';
import { humanize } from '../../seriesExtractors';

/**
 * Series picker for the combined chart. One group per metric chip that is on; the skeleton group
 * picks a joint first. A checked series shows its chart swatch (colour + dash) so the list
 * doubles as the legend key.
 *
 * layout: 'side' (column next to the chart, scrolls) | 'below' (grid under the chart) | 'stack' (mobile)
 */
export default function SeriesPanel({ groups, joint, joints, onJoint, onToggle, shownCount, onClose, layout }) {
    return (
        <aside aria-label="Series" className={cx('sd-series', `sd-series--${layout}`)}>
            <div className="sd-series__head">
                <span className="sd-series__title">Series</span>
                <span className="eg-small eg-secondary" style={{ fontWeight: 600 }}>{shownCount} shown</span>
                <Button variant="icon" bare icon="close" aria-label="Hide series panel" onClick={onClose} />
            </div>
            <div className="sd-series__groups">
                {groups.length ? groups.map((g) => (
                    <div key={g.key} className="sd-series__group">
                        <div className="sd-series__ghead">
                            <span className="eg-caps-14 eg-secondary" style={{ flex: 1 }}>{g.label}</span>
                            {g.failed ? <span className="eg-caps-14" style={{ color: 'var(--egdl-danger)' }}>Failed</span> : null}
                        </div>
                        {g.key === 'skeleton' && !g.failed && joints.length ? (
                            <SelectField
                                ariaLabel="Joint"
                                value={joint}
                                onChange={onJoint}
                                options={joints.map((j) => ({ value: j, label: humanize(j) }))}
                                className="sd-series__joint"
                            />
                        ) : null}
                        {g.failed ? <span className="sd-series__note">Didn’t load</span> : null}
                        {g.empty ? <span className="sd-series__note">Not recorded</span> : null}
                        {g.loading ? <span className="sd-series__note">Loading…</span> : null}
                        {g.items.map((it) => (
                            <CheckRow
                                key={it.key}
                                checked={it.checked}
                                disabled={g.failed}
                                onToggle={() => onToggle(it.key)}
                                trailing={it.checked && it.idx >= 0 ? <Swatch idx={it.idx} /> : null}
                            >
                                {it.item}
                            </CheckRow>
                        ))}
                    </div>
                )) : (
                    <div className="sd-series__group"><span className="sd-series__note">No metric turned on</span></div>
                )}
            </div>
        </aside>
    );
}
